import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {Router, ActivatedRoute} from "@angular/router";
import {FormBuilder, FormGroup} from "@angular/forms";
import {FormService} from "../../../fw/services/form.service";
import {SharedService} from "../../shared/shared.service";
import 'rxjs/add/operator/switchMap';
import {DtoCustomerOverview} from "./models/DtoCustomerOverview";
import {CustomerService} from "./customer.service";
import {DtoCustomerTreatmentSales} from "./models/DtoCustomerTreatmentSales";
import {DtoCustomerArticleSales} from "./models/DtoCustomerArticleSales";

@Component({
    selector: 'app-customers-customer',
    template: require('./customer.component.html'),
    styles: [require('./customer.component.css')]
})

@AutoUnsubscribe()
export class CustomerComponent implements OnInit {
    @ViewChild('gridTotalOverview', {static: false}) gridTotalOverview: DynamicGridComponent;
    @ViewChild('gridArticleSales', {static: false}) gridArticleSales: DynamicGridComponent;
    id: number;
    dtoObject: DtoCustomerOverview;
    totalOverview: DtoCustomerTreatmentSales[];
    articleSales: DtoCustomerArticleSales[];
    formFilterTotalOverview: FormGroup = this.fb.group({
        maxDate: this.ss.getCurrentDate()
    });
    formFilterArticleSales: FormGroup = this.fb.group({
        maxDate: this.ss.getCurrentDate()
    });
    pageHeaderConfig: PageHeaderBarConfig = {
        title: 'HOOFDGEGEVENS',
        buttonDefinition: []
    };
    totalOverviewColumnDefinition: ColumnDefinition[] = [
        {
            key: 'salesDateTime',
            label: 'Datum',
            type: 'string',
            width: '120px',
            format: '{0:dd-MM-yyyy}'
        },
        {
            key: 'treatmentDescription',
            label: 'Afgerekend',
            type: 'string',
            width: '*'
        },
        {
            key: 'amount',
            label: 'Aantal',
            type: 'string',
            width: '100px'
        },
        {
            key: 'totalPrice',
            label: 'Totaalbedrag',
            type: 'string',
            format: '{0:c}',
            width: '150px'
        },
        {
            key: 'payKind',
            label: 'Betaalwijze',
            type: 'string',
            width: '*'
        },
        {
            key: 'employeeName',
            label: 'Medewerker',
            type: 'string',
            width: '*'
        },
        {
            key: 'branch',
            label: 'Filiaal',
            type: 'string',
            width: '*'
        },
        {
            key: 'oa',
            label: 'Dagen geleden',
            type: 'string',
            width: '140px'
        }
    ];
    articleSalesColumnDefinition: ColumnDefinition[] = [
        {
            key: 'salesDateTime',
            label: 'Datum',
            type: 'string',
            width: '120px',
            format: '{0:dd-MM-yyyy}'
        },
        {
            key: 'articleDescription',
            label: 'Artikel',
            type: 'string',
            width: '*'
        },
        {
            key: 'amount',
            label: 'Aantal',
            type: 'string',
            width: '100px'
        },
        {
            key: 'piecePrice',
            label: 'Prijs',
            type: 'string',
            format: '{0:c}',
            width: '150px'
        },
        {
            key: 'totalPrice',
            label: 'Totaalbedrag',
            type: 'string',
            format: '{0:c}',
            width: '150px'
        },
        {
            key: 'employeeName',
            label: 'Medewerker',
            type: 'string',
            width: '*'
        },
        {
            key: 'branch',
            label: 'Filiaal',
            type: 'string',
            width: '*'
        }
    ];

    constructor(private breadcrumService: BreadcrumService,
                private ds: CustomerService,
                private fb: FormBuilder,
                private fs: FormService,
                private ss: SharedService,
                private router: Router,
                private route: ActivatedRoute) { }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'klanten', isLastStep: false },
            { text: '', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'customer-search');
        this.id = parseInt(this.route.snapshot.paramMap.get('id'));

        this.formFilterTotalOverview.get('maxDate').valueChanges.subscribe(newVal => {
            this.loadTotalOverview(true, newVal);
        });

        this.formFilterArticleSales.get('maxDate').valueChanges.subscribe(newVal => {
            this.loadArticleSales(true, newVal);
        });
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.loadData();
            this.loadTotalOverview(false, this.formFilterTotalOverview.value.maxDate);
        });
    }

    loadData() {
        if (this.id > 0) {
            this.ds.getCustomerById(this.id).subscribe((res: DtoCustomerOverview) => {
                this.dtoObject = res;
                this.breadcrumService.setLastStepDescription(this.dtoObject.name);
            });
        }
    }

    getBirthdate() {
        if (this.dtoObject && this.dtoObject.birthdate) {
            return this.ss.formatDate(this.dtoObject.birthdate) + ' (' + this.ss.getAge(this.dtoObject.birthdate) + ')';
        } else
            return '';
    }

    tabSelected(e) {
        if (e.index == 0) {
            this.loadTotalOverview(false, this.formFilterTotalOverview.value.maxDate);
        } else if (e.index == 1) {
            this.loadArticleSales(false, this.formFilterArticleSales.value.maxDate);
        }
    }

    loadTotalOverview(reload: boolean, checkDate: Date) {
        if (reload || !this.totalOverview) {
            this.ds.getCustomerTreatmentSales(this.id, checkDate).subscribe((res: DtoCustomerTreatmentSales[]) => {
                this.totalOverview = res;
                this.gridTotalOverview.showData(this.totalOverview);
            });
        }
    }

    loadArticleSales(reload: boolean, checkDate: Date) {
        if (reload || !this.articleSales) {
            this.ds.getCustomerArticleSales(this.id, checkDate).subscribe((res: DtoCustomerArticleSales[]) => {
                this.articleSales = res;
                this.gridArticleSales.showData(this.articleSales);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/customers/customer/customer.component.ts